module.exports = __webpack_public_path__ + "static/super-admin-category-form-536002c49422b37786c445363d04860f.png";